import { z } from 'zod';

// ID再設定フォームのバリデーションスキーマ
export const resetIdSchema = z
  .object({
    email: z
      .string()
      .min(1, 'メールアドレスは必須です')
      .email('有効なメールアドレスを入力してください'),
    confirmEmail: z.string().min(1, '確認メールアドレスは必須です'),
  })
  .refine((data) => data.email === data.confirmEmail, {
    message: 'メールアドレスが一致しません',
    path: ['confirmEmail'],
  });
